import type { Component, Entity2D } from '../../odie';
import { getGameScene } from '../getGameScene';

import { CountBlockOptionDef, AlarmBlockProps } from '../defs/block';
import { AlarmBlockView } from '../views/blocks/AlarmBlockView';

// types
//-----------------------------------------------------------------------------
export type AlarmBlockComponentOptions = {
  props: AlarmBlockProps;
  option?: number;
};

/*
    alarm block component
*/
export class AlarmBlockComponent implements Component {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'blockAlarm';

  // fields
  //-------------------------------------------------------------------------
  // injected
  public entity!: Entity2D;
  // scene
  public view!: AlarmBlockView;
  // state
  private _idle!: boolean;

  // properties
  //-------------------------------------------------------------------------
  private props!: AlarmBlockProps;
  // count
  public get count(): number {
    return this.view.count;
  }

  public set count(value: number) {
    this.view.count = value;
    this._idle = false;
  }

  // idle
  public get idle(): boolean {
    return this._idle;
  }

  public set idle(value: boolean) {
    this._idle = value;
  }

  // impl
  //-------------------------------------------------------------------------
  public init(options: AlarmBlockComponentOptions): void {
    // get option def
    const optionDef = options.props.options?.[
      options.option || 0
    ] as CountBlockOptionDef;

    this.props = options.props;

    // create view
    this.view = new AlarmBlockView(options.props);

    // set initial count
    this.count = optionDef.count;

    // Set initial idle state. This block is a bit different from the others as it starts idle regardless
    // of option defined, but that should change if the game is being loaded from a save state.
    this._idle = getGameScene()?.usingSaveState ? this.count !== 0 : true;

    // Set the getGameplayState retrieval function
    this.entity.c.block.getGameplayState = () => this.getGameplayState();
  }

  public getGameplayState(): number {
    const options = this.props.options as CountBlockOptionDef[];
    return options.findIndex((opt) => {
      return opt.count === this.view.count;
    });
  }
}
